import React from "react";
import styled from "styled-components";

function PageContentWrapper2({ children }) {
  return (
    <Wrapper>
      {children}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 800px;
  height: 100%;
  align-items: center;
  margin-top: 50px;
  padding: 0px 10px;
`;

export default PageContentWrapper2;